var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "tab_ul" },
    _vm._l(_vm.navTabArr, function(item, index) {
      return _c(
        "li",
        {
          key: index,
          class: ["tab_li", { active_nav: _vm.navTabVal === item.value }],
          on: {
            click: function($event) {
              return _vm.emitFn(item, index)
            }
          }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.currentAuthUser.corpUserId && item.change
                  ? "我参与签/审的"
                  : item.label
              ) +
              "（" +
              _vm._s(_vm.countFn(item.value)) +
              "）\n  "
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c16f911", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c16f911","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/nav-tab/navTab.vue
// module id = QqaO
// module chunks = 27 29 103